import React from 'react';
import PropTypes from 'prop-types';
import sampleDarkBlueIcon from '../../../images/sample-icon_darkblue.png';
import weightedDarkBlueIcon from '../../../images/weighted-icon_darkblue.png';
import verticalDarkBlueIcon from '../../../images/vertical-icon-down_darkblue.png';
import horizontalDarkBlueIcon from '../../../images/horizontal-icon_darkblue.png';
import indexDarkBlueIcon from '../../../images/index-icon_darkblue.png';

import { checkWeightType } from '../../../util/CommonUtils';

const CrosstabColumnHeader = ({ metricsList, metricsCount, crosstabWeightTypes, rowHeight }) => {

  const cellHeight = `${(parseInt(rowHeight, 10) / metricsCount) - 1}px`;
  const style = { height: cellHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' };
  const imgStyle = { height: '16px' };
  return (
    <div>
      {metricsList[0] && <div className="" title="SAMPLE" style={style}>
        <img
          src={sampleDarkBlueIcon} alt="SAMPLE"
          className="labelIcon"
          style={imgStyle}
        />
      </div>}
      {metricsList[1] && <div className="" title={`WEIGHTED${checkWeightType(crosstabWeightTypes)}`} style={style}>
        <img
          src={weightedDarkBlueIcon} alt={`WEIGHTED${checkWeightType(crosstabWeightTypes)}`}
          className="labelIcon"
          style={imgStyle}
        />
      </div>}
      {metricsList[2] && <div className="" title="VERTICAL%" style={style}>
        <img
          src={verticalDarkBlueIcon} alt="VERTICAL%"
          className="labelIcon"
          style={imgStyle}
        />
      </div>}
      {metricsList[3] && <div className="" title="HORIZONTAL%" style={style}>
        <img
          src={horizontalDarkBlueIcon} alt="HORIZONTAL%"
          className="labelIcon"
          style={imgStyle}
        />
      </div>}
      {metricsList[4] && <div className="" title="INDEX" style={style}>
        <img
          src={indexDarkBlueIcon} alt="INDEX"
          className="labelIcon"
          style={imgStyle}
        />
      </div>}
    </div>
  );
};

CrosstabColumnHeader.propTypes = {
  metricsList: PropTypes.arrayOf(PropTypes.bool),
  crosstabWeightTypes: PropTypes.shape({}),
  metricsCount: PropTypes.number,
  rowHeight: PropTypes.string,
};

export default CrosstabColumnHeader;
